var buttons = $('[data-disabledfor]');
$.each(buttons, function (index, element) {
    element.addEventListener('click', function (e) {
        var $target = $(e.target);
        if ($target.prop('isdisabled')) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        $target.prop('isdisabled', true);

        if ($target.data('disablepermanent')) {
            return;
        }

        var disableFor = parseInt($target.data('disabledfor'));
        if (disableFor > 0) {
            setTimeout(function () {
                $target.prop('isdisabled', false);
            }, disableFor);
        }
    }, true);
});